module.exports = __webpack_public_path__ + "7642d23d2a4223c41caaf2ca20f2a917.pdf";